module.exports = __webpack_public_path__ + "static/media/receivables.6ae1727d.png";